import { OutlinedInput, Typography, FormControl, FormHelperText, InputAdornment, IconButton } from '@mui/material';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import { Controller } from 'react-hook-form';
import * as React from 'react';

function CustomInputPassword({ control, name, formLabel, description, noPadding = false, ...props }) {
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <FormControl variant="outlined" error={fieldState.invalid} style={{ paddingBottom: noPadding ? 0 : '8px' }}>
                    {formLabel && (
                        <Typography style={{ paddingBottom: description ? 0 : '4px', fontWeight: 700, color: '#666' }}>
                            {formLabel}
                        </Typography>
                    )}
                    {description && <Typography variant="caption">{description}</Typography>}
                    <OutlinedInput
                        {...field}
                        {...props}
                        type={showPassword ? 'text' : 'password'}
                        onChange={(e) => {
                            field.onChange(e);
                            if (props.onChange != null) {
                                props.onChange(e);
                            }
                        }}
                        sx={{
                            '& input:-webkit-autofill': {
                                WebkitBoxShadow: '0 0 0 100px #E8F0FE inset',
                                WebkitTextFillColor: 'inherit'
                            }
                        }}
                        onBlur={(e) => {
                            field.onBlur();
                            if (props.onBlur != null) {
                                props.onBlur(e);
                            }
                        }}
                        endAdornment={
                            <InputAdornment position="end" sx={{ width: 40, justifyContent: 'center', m: 0 }}>
                                <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} edge="end">
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                    <FormHelperText style={{ margin: '3px 0 0 0' }}>{fieldState.error?.message}</FormHelperText>
                </FormControl>
            )}
        />
    );
}

export default CustomInputPassword;
